
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forget-password",
      function () {
        return require("private-next-pages/auth/forget-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/forget-password"])
      });
    }
  